<template>
    <FormSection>
        <template v-slot:title>
            {{ $t('messages.change_password') }}
        </template>
        <template v-slot:content>
            <form action="" @submit.prevent="submit">
                <div class="px-4 py-5 sm:p-6">
                    <div class="md:grid-cols-6 md:gap-6">
                        <div class="sm:col-span-3">
                            <div class="mt-1">
                                <label for="current_password" class="block text-sm font-medium leading-5 text-gray-700">
                                    {{ $t('messages.current_password') }}
                                </label>
                                <div class="mt-1 rounded-md">
                                    <input
                                        id="current_password"
                                        v-model="form.current_password"
                                        name="current_password"
                                        type="password"
                                        ref="current_password"
                                        autocomplete="current_password"
                                        minlength="8"
                                        class="appearance-none block px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                </div>
                                <p class="mt-2 text-sm text-red-600" v-if="form.errors.current_password">
                                    {{ form.errors.current_password }}
                                </p>
                            </div>
                        </div>

                        <div class="sm:col-span-3">
                            <div class="mt-1">
                                <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
                                    {{ $t('messages.new_password') }}
                                </label>
                                <div class="mt-1 rounded-md">
                                    <input
                                        id="password"
                                        v-model="form.password"
                                        name="password"
                                        type="password"
                                        ref="password"
                                        autocomplete="new-password"
                                        minlength="8"
                                        class="appearance-none block px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                    <p class="mt-2 text-sm text-red-600" v-if="form.errors.password">
                                        {{ form.errors.password }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="sm:col-span-3">
                            <div class="mt-1">
                                <label
                                    for="password_confirmation"
                                    class="block text-sm font-medium leading-5 text-gray-700"
                                >
                                    {{ $t('messages.password_repeat') }}
                                </label>
                                <div class="mt-1 rounded-md">
                                    <input
                                        id="password_confirmation"
                                        v-model="form.password_confirmation"
                                        name="password_confirmation"
                                        type="password"
                                        autocomplete="new-password"
                                        minlength="8"
                                        class="appearance-none block px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md"
                >
                    <div class="mt-1">
                        <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                    </div>
                </div>
            </form>
        </template>
    </FormSection>
</template>

<script>
import FormSection from '@/components/FormSection.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    name: 'UpdatePasswordForm',
    components: {
        SubmitFormButton,
        FormSection,
    },
    data() {
        return {
            form: this.$inertia.form({
                password: '',
                password_confirmation: '',
                current_password: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.route('common.password.update'), {
                // errorBag: 'updatePassword',
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: () => {
                    if (this.form.errors.password) {
                        this.form.reset('password', 'password_confirmation');
                        this.$refs.password.focus();
                    }

                    if (this.form.errors.current_password) {
                        this.form.reset('current_password');
                        this.$refs.current_password.focus();
                    }
                },
            });
        },
    },
};
</script>
